import { Button, Col, Container, OfficeMap, Row, Section } from 'atoms'
import { ContactCard } from 'organisms'
import { FC } from 'react'

import Styles from './Informationen.module.sass'

const Informationen: FC<unknown> = () => (
  <>
    <Section background="rose">
      <Container>
        <h1>
        Informationen
        </h1>
      </Container>
    </Section>
    <Section>
      <Container className="my-5">
        <Row>
          <Col xs={12} md={6}>
            <Button block theme="green" href="/informationen/ihr-coach">
              Ihr Coach Cordelia Schmidt
            </Button>
          </Col>
          <Col xs={12} md={6}>
            <Button block theme="blue" href="/informationen/fragen-und-antworten">
              Fragen und Antworten
            </Button>
          </Col>
        </Row>
      </Container>
    </Section>
    <Section className={Styles.sectionMap}>
      <OfficeMap />
    </Section>
    <Section background="vintage">
      <Container>
        <ContactCard />
      </Container>
    </Section>
  </>
)

export default Informationen
